
import Vue from 'vue'

export default Vue.extend({
  name: 'BaseCloseButton',

  computed: {
    disabled(): boolean {
      return this.$globalData.loading || this.$globalData.checked
    }
  },

  methods: {
    emitClick(): void {
      if (this.disabled) return
      this.$emit('click')
    }
  },
})
